import { createSlice } from "@reduxjs/toolkit";
import { convertArrayToObject } from "../../helpers/catalog-helper";
import { ADDONS_ACTIONS } from "../../data/addOns-constants";
import { userNormalLogout, supportLogout } from "../actions";

export interface AddOnsState {
  optionSetsDataMap: {};
  lastKey: Record<string,string>,
  currentAction: string
}

const initialState: AddOnsState = {
  optionSetsDataMap: {},
  lastKey: {},
  currentAction: ''
};

export const addOnsSlice = createSlice({
  name: "addOns",
  initialState,
  reducers: {
    getAllOptionSetsData: (state, actions) => {},
    getSingleOptionSetData: (state, actions) => {},
    saveAllOptionSetsData: (state, actions) => {
      if(actions.payload.addOnsAction === ADDONS_ACTIONS.DELETE
        || actions.payload.addOnsAction === ADDONS_ACTIONS.SAVE
        || actions.payload.addOnsAction === ADDONS_ACTIONS.SEARCH
        )
      {
        state.optionSetsDataMap = actions.payload?.response?.results?.length
        ? convertArrayToObject(actions.payload.response.results, "mid")
        : {}
      }
      else {
      state.optionSetsDataMap = {...state.optionSetsDataMap, ...actions.payload?.response?.results?.length
        ? convertArrayToObject(actions.payload.response.results, "mid")
        : {}}
      }
      state.lastKey = actions.payload?.response?.lastKey || {}
      state.currentAction = actions.payload.addOnsAction || ADDONS_ACTIONS.FETCH_ACTION
    },
    deleteOptionSetData: (state, actions) => {},
    deleteOptionSetVariantData: (state, actions) => {},
    addNewOptionSetData: (state, actions) => {},
    updateOptionSetData: (state, actions) => {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(userNormalLogout, () => initialState)
      .addCase(supportLogout, () => initialState);
  },
});

export const {
  getAllOptionSetsData,
  getSingleOptionSetData,
  saveAllOptionSetsData,
  addNewOptionSetData,
  updateOptionSetData,
  deleteOptionSetData,
  deleteOptionSetVariantData,
} = addOnsSlice.actions;
export default addOnsSlice.reducer;
